import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Component, OnInit, ViewChild, HostListener } from '@angular/core';

// Models
import { User, UserBalance, accountStatus } from 'src/app/modules/account/models/user';
import { MenuItem, NavbarConfig, PlatformEvent } from 'src/app/platform/models/utils';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { ApiService } from 'src/app/platform/services/api.service';
import { UserService } from 'src/app/modules/account/user.service';
import { DeviceService } from 'src/app/platform/services/device.service';
import { AccountsService } from 'src/app/modules/account/accounts.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';

// Components
import { UiDialogComponent } from 'src/app/platform/components/ui-dialog/ui-dialog.component';
import { UiBottomSheetComponent } from 'src/app/platform/components/ui-bottom-sheet/ui-bottom-sheet.component';
import { AccountDeleteComponent } from 'src/app/modules/account/views/account-delete/account-delete.component';
import { AccountsAdminSelectComponent } from './modules/account/components/accounts-admin-select/accounts-admin-select.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  public interfase: boolean;
  public navbarConfig: NavbarConfig = new NavbarConfig();
  public user: User = new User();
  public screen: any;
  public menuItems: MenuItem[];
  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private location: Location,
    private uiDialog: MatDialog,
    private uiService: UiService,
    private apiService: ApiService,
    private userService: UserService,
    private accountsService: AccountsService,
    private bottomSheet: MatBottomSheet,
    private platformService: PlatformService,
    private proceduresService: ProceduresService,
    private deviceService: DeviceService
  ) {
    this.deviceService.init();

    this.deviceService.linkOpened.subscribe((path: string) => {
      if (this.userService.isLogged() && this.accountsService.isAccountSelected()) {
        console.log('Deep link opened:', path);

        this.router.navigateByUrl(path);
      }
    });
    
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd && val && this.isLogged()) {
        if (this.location.path() === '/facturas' || this.location.path() === '/resumen') {
          this.accountsService.accountGet(this.accountsService.accountCurrentGet()).then((success) => {
            this.userService.updateData('balance', new UserBalance().configData(success.result));
          }).catch((error) => {
            console.log('Error to update account data.');
          });
        }
      }
    });

    this.uiService.navbarConfig.subscribe((config) => {
      this.updateNavbarConfig(config);
    });

    this.apiService.tokenValidation.subscribe((valid) => {
      if (valid === false) {
        userService.logout();

        // If you are on the payments screen, you do not need to be logged in, therefore it does not redirect.
        // If these variables increase in quantity it may be better to make a handler
        if (['/dgo', '/pagos/pago'].includes(this.location.path().split('?')[0])) {
          // Nothing todo
        } else {
          this.router.navigate(['ingreso'], { queryParams: { from: 'tokenInvalid' } });
        }
      }
    });

    this.userService.currentUser.subscribe((user) => {
      this.user = user;

      if (this.userService.isLogged() && this.accountsService.isAccountSelected()) {
        this.uiService.setInterfaseConfig(true);
      } else {
        this.uiService.setInterfaseConfig(false);
      }
    });

    this.platformService.events.addListener(PlatformEvent.GO_BACK, () => {
      this.onBackPressed();
    });

    this.platformService.screen.subscribe(params => {
      this.screen = params;
    });

    this.uiService.interfaseShow.subscribe((config) => {
      this.interfase = config;
    });
  }

  ngOnInit(): void {
    if (this.isLogged()) {
      if (this.location.path() === '') {
        this.router.navigate(['resumen']);
      }
    } else {
      // If you are on the reset or payments screen, you do not need to be logged in, therefore it does not redirect.
      // If these variables increase in quantity it may be better to make a handler
      if (['/dgo', '/ingreso', '/restablecer', '/registro', '/pagos/pago'].includes(this.location.path().split('?')[0])) {
        // Nothing todo
      } else {
        this.router.navigate(['ingreso']);
      }
    }

    this.menuItems = [
      {menu: 'principal', icon: 'home', title: 'Resumen de mi cuenta', route: '/resumen'},
      {menu: 'principal', icon: 'view_list', title: 'Productos contratados', route: '/productos-contratados'},
      {menu: 'principal', icon: 'verified', title: 'Productos disponibles', route: '', action: (): void => { window.open('https://www.iptel.com.ar/', '_blank'); }},
      {menu: 'principal', icon: 'receipt', title: 'Mis facturas', route: '/facturas'},
      {menu: 'principal', icon: 'local_atm', title: 'Mis pagos', route: '/pagos'},
      {menu: 'principal', icon: 'add_task', title: 'Mis gestiones', route: '/gestiones'},
      {menu: 'principal', icon: 'account_circle', title: 'Mis datos', route: '/cuenta'},

      {menu: 'secundario', icon: 'campaign', title: 'Novedades', route: '', action: () => { window.open('https://www.iptel.com.ar/blog/', '_blank'); }},
      {menu: 'secundario', icon: 'card_giftcard', title: 'Promociones', route: '', action: () => { window.open('https://www.iptel.com.ar/promociones/', '_blank'); }},
      {menu: 'secundario', icon: 'support', title: 'Atención al cliente', route: '', action: () => { window.open('https://www.iptel.com.ar/atencion-al-cliente/centros-de-atencion-al-cliente/', '_blank'); }},
      {menu: 'secundario', icon: 'payment', title: 'Medios de pago', route: '', action: () => { window.open('https://www.iptel.com.ar/atencion-al-cliente/medios-de-pago/', '_blank'); }},
      {menu: 'secundario', icon: 'exit_to_app', title: 'Salir', route: '', action: () => { this.onLogout(); }},
    ];
  }

  /**
   * Detect screen resizing to configure interface
   */
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.platformService.onWindowResize(event);
  }

  /**
   * Check if a user session is started
   */
  isLogged(): boolean{
    return this.userService.isLogged() && this.accountsService.isAccountSelected();
  }

  /**
   * Used to safely update the navbar config without triggering an
   * ExpressionChangedAfterItHasBeenCheckedError.
   */
  updateNavbarConfig(config: NavbarConfig): void {
    if (this.navbarConfig) {
      setTimeout(() => {
        this.navbarConfig = config;
      }, 1);
    } else {
      this.navbarConfig = config;
    }
  }

  onAccountMenuOpen(): void {
    this.bottomSheet.open(UiBottomSheetComponent);
  }

  accountStatus(status: string): string {
    return accountStatus(status);
  }

  /**
   * Change account to manage
   */
  onAccountSelect(account: number): void{
    if (account) {
      if (account !== this.user.client) {
        this.uiService.showSpinner(true);

        this.accountsService.accountSet(account).then((status: boolean) => {
          this.uiService.showSpinner(false);

          if (this.accountsService.isAccountSelected()) {
            this.router.navigate(['resumen'], { queryParamsHandling: 'merge' });

            this.proceduresService.proceduresUpdate(true);
          } else {
            this.uiService.showSnackBar('No es posible administrar la cuenta ' + account + ' en este momento (AC002).');
          }
        }, (error) => {
          this.uiService.showSpinner(false);
          this.uiService.showSnackBar(error);
        });
      }
    } else {
      this.uiService.showSnackBar('No es posible administrar la cuenta ' + account + ' en este momento (AC001).');
    }
  }

  onAdminAccountSearch(): void {
    this.uiDialog.open(AccountsAdminSelectComponent, {
      width: '400px',
    });
  }

  /**
   * Executed when the GO_BACK event is received.
   */
  onBackPressed(): void {
    if (this.sidenav && this.sidenav.opened) {
      this.sidenav.close();
    } else {
      this.location.back();
    }
  }

  /**
   * Shows a pop up to confirm logout.
   */
  onLogout(): void {
    this.uiDialog.open(UiDialogComponent, {
      width: '250px',
      data: {
        title: '¿Cerrar sesión?',
        message: '¿Esta seguro que desea salir de la sesión actual?',
        buttonCancelText: 'Cancelar',
        buttonConfirmText: 'Si, salir',
        action: () => {
          this.userService.logout();
          //this.router.navigate(['ingreso'], { queryParams: { from: 'logout' } });
          //this.router.navigateByUrl('/ingreso?from=logout');
          //console.log('/ingreso?from=logout')
          //this.deviceService.biometricDeleteCredentials();
        }
      }
    });
  }

  onUnsuscribe(): void {
    this.dialog.open(AccountDeleteComponent, {
      width: '400px',
    });
  }

  onUnsuscribeCancel(): void {
    this.uiDialog.open(UiDialogComponent, {
      width: '400px',
      data: {
        title: 'Cancelar bajas solicitadas',
        message: 'Estas a punto de cancelar todas las bajas que solicitaste recientemente, ya sea de tu cuenta en general como cualquier producto o servicio particular. ¿Estás seguro de continuar?',
        type: 'info',
        buttonCancelText: 'Cancelar',
        buttonConfirmText: 'Si, anular bajas',
        action: () => {
          this.uiService.showSpinner(true);

          this.accountsService.accountDeleteCancel().then((result) => {
            if (result.status) {
              this.uiService.showSpinner(false);
              this.uiService.dialogShow('Cancelar bajas solicitadas', 'Se anularon todas las bajas pendientes que habías realizado.</p>', 'success');

              this.userService.updateData('unsuscribeAccount', false);
              this.userService.updateData('unsuscribeServices', false);
              this.accountsService.accountsDataUpdate();
            }
            else {
              this.uiService.showSpinner(false);
              this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar anular las bajas realizadas. Por favor intenta nuevamente.', 'error');
            }
          }, (error) => {
            this.uiService.showSpinner(false);
            this.uiService.dialogShow('Ups!', 'No es posible anular las bajas realizadas en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
          });
        }
      }
    });
  }
}
